import { TextField, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { string, func } from "prop-types";

type KeyTextFieldProps = React.ComponentProps<typeof TextField>;

export const KeyTextField = (props: KeyTextFieldProps) => {
  const allowedChars = /^[0-9a-z-]+$/;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const theme = useTheme();

  const value = typeof props.value === "string" ? props.value : "";
  const error = value && !allowedChars.test(value);

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = (
      event.clipboardData || (window as any).clipboardData
    ).getData("text");
    // Validate the pasted text using the regular expression
    if (!allowedChars.test(pastedText)) {
      event.preventDefault(); // Prevent default pasting behavior if invalid
    }

    if (typeof props.onPaste === "function") {
      props.onPaste(event);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    // Only allow valid values or empty string
    if (newValue === "" || allowedChars.test(newValue)) {
      if (typeof props.onChange === "function") {
        props.onChange(event);
      }
    } else {
      // Prevent the change by not calling onChange
      event.preventDefault();
    }
  };

  return (
    <TextField
      {...props}
      value={value}
      onChange={handleChange}
      onPaste={handlePaste}
      error={error}
      helperText={
        error
          ? gettext(
              "Only lowercase alphanumeric characters and dashes are allowed",
            )
          : ""
      }
      sx={{
        inputProps: {
          style: {
            ...(!error ? {} : { backgroundColor: theme.palette.error.light }),
          },
        },
      }}
    />
  );
};

KeyTextField.propTypes = {
  value: string,
  onChange: func,
  onPaste: func,
};
